import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

import CustomProperty from "./Modules/CustomProperty.js";

CustomProperty();
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const track = document.getElementById('js-track');
const viewport = document.getElementById('js-viewport')
const world = document.getElementById('js-world');
const object = document.getElementById('js-object');
const path = document.getElementById('js-path');
const length = path.getTotalLength();


const setWorldX = gsap.quickSetter(world, "x", "px");
const setWorldY = gsap.quickSetter(world, "y", "px");
const tl = gsap.timeline({});
const position = {
  start: {x: 0, y: 0},
  current: {x: 0, y: 0},
}
const offsetX = world.offsetWidth - viewport.clientWidth;
const offsetY = world.offsetHeight - viewport.clientHeight;
tl.to(object, {
  ease: "none",
  scrollTrigger: {
    trigger: track,
    pin: viewport,
    scrub: true,
    start: "top top",
    markers: true,
    end: () => `+=${length}`,
  },
  motionPath: {
    path: path,
    align: path,
    autoRotate: true,
    alignOrigin: [1, 0.5],
  },
  onStart: () => {
    position.start.x = gsap.getProperty(object, "x");
    position.start.y = gsap.getProperty(object, "y");
  },
  onUpdate: () => {
    position.current.x = gsap.getProperty(object, "x");
    position.current.y = gsap.getProperty(object, "y");
    const diffX = (position.start.x - position.current.x) / world.offsetWidth * offsetX;
    const diffY = (position.start.y - position.current.y) / path.getBoundingClientRect().height * offsetY;
    setWorldX(diffX);
    setWorldY(diffY);
  },
});